/** CoStar.Api.Maps.Transit.LogoAttachmentType */
export var LogoAttachmentType;
(function (LogoAttachmentType) {
    LogoAttachmentType[LogoAttachmentType["None"] = 0] = "None";
    LogoAttachmentType[LogoAttachmentType["Airport"] = 1] = "Airport";
    LogoAttachmentType[LogoAttachmentType["Line"] = 2] = "Line";
    LogoAttachmentType[LogoAttachmentType["System"] = 3] = "System";
    LogoAttachmentType[LogoAttachmentType["College"] = 4] = "College";
})(LogoAttachmentType || (LogoAttachmentType = {}));
/** CoStar.Api.Maps.Transit.TransitPointOfInterestType */
export var TransitPointOfInterestType;
(function (TransitPointOfInterestType) {
    TransitPointOfInterestType[TransitPointOfInterestType["None"] = 0] = "None";
    TransitPointOfInterestType[TransitPointOfInterestType["Airport"] = 1] = "Airport";
    TransitPointOfInterestType[TransitPointOfInterestType["CommuterRailStation"] = 2] = "CommuterRailStation";
    TransitPointOfInterestType[TransitPointOfInterestType["TransitStation"] = 3] = "TransitStation";
    TransitPointOfInterestType[TransitPointOfInterestType["College"] = 4] = "College";
    TransitPointOfInterestType[TransitPointOfInterestType["MilitaryBase"] = 5] = "MilitaryBase";
    TransitPointOfInterestType[TransitPointOfInterestType["Park"] = 6] = "Park";
    TransitPointOfInterestType[TransitPointOfInterestType["ShoppingCenter"] = 7] = "ShoppingCenter";
})(TransitPointOfInterestType || (TransitPointOfInterestType = {}));
